import React, { useRef, useEffect } from "react";
import Messages from "./Messages";
import Input from "./Input";
import { useDispatch, useSelector } from "react-redux";
import {
  changeIsUserSelected
} from "../../reducers/enqChatSlice";
import Products from "./Products";
import { Toast } from "primereact/toast";
import { CustomButton } from "../../components/CustomButton";
import { Text } from "../../components/Text";
import FileInputsComponenets from "../../components/FileInputsComponents";
import AgentPlace from "./AgentPlace";
import TicketReasign from "./TicketReasign";
import { formatMobNumber } from "../../utils/commonUtils";
import { Menu } from "primereact/menu";
import modulesName from "../../roles/modulesName";
import permissions from "../../roles/permissions";
import { ReactComponent as AddToGroupIcon } from "./../../svg/addToGroupIcon.svg"

import CopyToClipboard from "../../components/CopyToClipboard";
import ChatControlMenu from "./components/chat-control-menu";
import { Button } from "primereact/button";
import ChatTagSelector from "./tags";

const Chat = ({ setAddToGroupSliderOpen }) => {
  const {
    user,
    isFileSelect,
    isProductSelect,
    isImageSelect,
    isVideoSelect,
  } = useSelector((state) => state.enqChats);
  const { accesskey, user:User  } = useSelector((state) => state.authenticate);
  const dispatch = useDispatch();
  const toast = useRef(null);
  const menuButtonRef = useRef(null);
  const mobNumber = formatMobNumber(user?.phone)

  let items = [{
    label: mobNumber,
    icon: 'pi pi-copy',
    command: () => {
      navigator.clipboard.writeText(mobNumber);
      toast.current.show({ severity: 'success', detail: 'Copied on clipboard ', life: 3000 });
    }
  }];

  function ChatHeader() {
    return (
      <div className="flex align-items-center gap-1">
        <CustomButton varient="icon-button md:hidden" icon={"pi pi-arrow-left"} onClick={() => dispatch(changeIsUserSelected(false))} />
        <Text type="sub-heading" cust="flex align-items-center">
          <div className="capitalize mr-3">
            <Text type={"sub-heading"}>{user?.businessName || mobNumber}</Text>
          </div>
          <div>
            {user?.businessName ? <Button text rounded className="h-auto" icon={"pi pi-info-circle"} onClick={(event) => menuButtonRef.current.toggle(event)} /> : <CopyToClipboard toClipboard={mobNumber} />}
          </div>
        </Text>
      </div>
    );
  }
  
  const isSuperAdmin = User?.role === "superadmin"
  return (
    <div className="h-full">
      <Toast ref={toast} />
      <Menu model={items} popup ref={menuButtonRef} id="menu_button" />
      <div className="flex flex-column h-full ">
        {!accesskey[modulesName.SALES]?.includes(permissions.UPDATE) && (
          <AgentPlace />
        )}
        {Object.keys(user)?.length != 0 && (
          <>
            <div className="chatInfo p-2">
              <div className="flex flex-column md:flex-row justify-content-between  align-items-start md:align-items-center">
                <div className="w-auto">{ChatHeader()}</div>
                <div className="flex justify-content-end align-items-center flex-grow-1">
                  <TicketReasign />
                  {accesskey[modulesName.CUSTOMER]?.includes(permissions.CREATE) && (<Button
                    text
                    rounded
                    className="ml-1"
                    icon={<AddToGroupIcon />}
                    onClick={() => setAddToGroupSliderOpen((prev) => !prev)}
                  />)}
                   { isSuperAdmin &&  <ChatControlMenu chatInfo={user} />}
                </div>
              </div>
                <ChatTagSelector mobNumber = {mobNumber}/>
            </div>

            {isFileSelect ? (
              <FileInputsComponenets />
            ) : isImageSelect ? (
              <FileInputsComponenets />
            ) : isVideoSelect ? (
              <FileInputsComponenets />
            ) : isProductSelect ? (
              <Products />
            ) : (
              <>
                <Messages />
                <Input />
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Chat;
